import React,{Component} from 'react';
import { IonRouterLink, IonLoading } from '@ionic/react';

import './Login.css';
// import classNames from 'classnames';

// Redux
import { connect } from 'react-redux';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { homeBanner, logo } from '../../theme/images';
import routes from '../../utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import { go_back, push_history } from '@acri-tools/react-tools/utils/global';
import { login } from '@acri-tools/react-tools/utils/login';
import { setLogin } from '@acri-tools/react-tools/redux/actions';
import Footer from '../../components/Footer/Footer';

// components
// methods
interface Props{
    history?:any,

    setLogin?:any,
}

class Login extends Component<Props,{}>{
    state={
        email:'',
        password:'',
        loggingIn:false,
        hasEntered:false,
        message: '',
        messageType: 'error'
    }
    render(){
        return (
            <Page 
                id="login"
                footer={<Footer />}
                topBar={{
                    logo: logo,
                    routes: routes,
                    // history: this.props.history,
                }}
            >
                <IonLoading
                    isOpen={this.state.loggingIn}
                    message={'Logging In...'}
                />
                <div 
                    className="page-content"
                    style={{
                        backgroundImage:`url(${homeBanner})`
                    }}
                >
                    <div id="login-container" className="form-container">
                        <div className="form">
                            <div className="form-field large">
                                <label>
                                    <i  className="far fa-envelope" />
                                    Email - Username
                                </label>
                                <input 
                                    type="email" value={this.state.email} placeholder={"Email - Username"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({email:e.target.value}); }}/>
                            </div>
                            <div className="form-field large">
                                <label>
                                    <i className="fas fa-key" />
                                    Password
                                </label>
                                <input 
                                    type="password" value={this.state.password}  placeholder={"Password"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({password:e.target.value}); }}/>
                            </div>
                            <Message message={ this.state.message } type={ this.state.messageType }/>
                        </div>
                        
                        {/* <br/>
                        <IonRouterLink className="custom-link" routerLink='/forgot-password'><i className="fas fa-question-circle"/> Forgot Password</IonRouterLink>
                        <br/> */}

                        <div className="custom-button login" onClick={this.login}>LOGIN</div>
                        {/* <h2 className="divider"><div className="line"/><span>OR</span><div className="line"/></h2>
                        <div className="custom-button register" onClick={()=>{ push_history('/register') }}>REGISTER</div> */}
                    </div>  
                </div>
            </Page>
        );
    }

    inputTyped = () =>{
        this.setState({
            message: ''
        })
    }
    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.login();
        }
    }
    login = async() =>{
        if(!this.state.email){
            this.setState({
                message: 'Missing Username or Email',
                messageType: 'warn'
            })
        }
        else if(!this.state.password){
            this.setState({
                message: 'Missing Password',
                messageType: 'warn'
            })
        }
        else{
            this.setState({loggingIn:true});
            
            let login_status = await login(true,this.state.email,this.state.password);
            this.setState({ loggingIn:false });
            if(login_status.success){
                go_back();
            }
            else{
                this.setState({
                    message: login_status.error ? login_status.error : '',
                    messageType: 'error'
                })
            }
        }
    }
};

const mapStateToProps = (state:any) =>{
    return {
        login : state.login
    }
}

export default connect(mapStateToProps,{ setLogin })(Login);
